export default __webpack_public_path__ + "static/media/misc-pantry3-768w.1b318b37.webp";